import React from 'react'

function Pagination({ children }) {
  return (
    <div className="search__pagination wrapper u-mt-100 u-mr-100 u-ml-100">
        {children}
    </div>
  )
}

export default Pagination
